import { render, staticRenderFns } from "./HSBCForm.vue?vue&type=template&id=1c78a0e5"
import script from "./HSBCForm.vue?vue&type=script&lang=js"
export * from "./HSBCForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports